import { Component, OnInit } from '@angular/core';
import {GLOBAL} from "../../services/GLOBAL";

@Component({
  selector: 'app-convenios',
  templateUrl: './convenios.component.html',
  styleUrls: ['./convenios.component.css']
})
export class ConveniosComponent implements OnInit {

  public global = GLOBAL;

  constructor() { }

  ngOnInit(): void {
  }

}
